import { useEffect, useState } from "react";
import api from "../utils/axios";
import Swal from 'sweetalert2'
import UserRowSkeleton from "../components/Skeleton/UserRowSkeleton";

export default function GiftCode() {

    const [giftCodeList, setGiftCodeList] = useState([]);
    const [id_redenvelope, setIdRedenvelope] = useState('');
    const [money, setMoney] = useState('');
    const [status, setStatus] = useState('active');
    const [for_new_users, setForNewUsers] = useState('');
    const [expire_date, setExpireDate] = useState('');
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [used, setUsed] = useState('false'); // default: unused


    useEffect(() => {
    fetchGiftCodeList();
}, [page, status, used]);



  const fetchGiftCodeList = async () => {
    setLoading(true);
    try {
        const res = await api.get('/getRedenvelope', {
            params: {
                page,
                limit,
                status,
                used: used === 'all' ? undefined : used,
            },
        });

        setGiftCodeList(res.data.redenvelopes || []);
        setTotalPages(res.data.totalPages || 1);
    } catch (error) {
        console.error('Failed to fetch gift codes', error);
    } finally {
        setLoading(false);
    }
};


    const createGiftCode = async () => {
        try {
            if (!id_redenvelope || !money || !status || !for_new_users || !expire_date) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: 'All fields are required!',
                });
                return;
            }
            const response = await api.post('/createRedenvelope', {
                id_redenvelope: id_redenvelope,
                money: money,
                status: status,
                for_new_users: for_new_users,
                expire_date: expire_date,
            });
            console.log(response.data);
            if (response?.data.status == false) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error...',
                    text: response.data.msg,
                });
                return;
            }
            Swal.fire({
                icon: 'success',
                title: 'Success...',
                text: 'Gift Code created successfully!',
            });
            fetchGiftCodeList();
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error...',
                text: error.response.data.msg,
            });
            console.log(error);
        }
    };


    return (
        <div className="space-y-8">
            <div>
                <h1 className="text-2xl font-bold text-gray-800">
                    Redenvelope Methods
                </h1>
                <p className="text-sm text-gray-500">
                    Manage redenvelope methods and settings for user transactions.
                </p>
            </div>

            {/* ================= FORM ================= */}
            <div className="bg-white border rounded-xl p-6 shadow-sm">
                <h2 className="text-lg font-semibold mb-4">
                    Add Gift Code
                </h2>

                <form
                    className="grid grid-cols-1 md:grid-cols-2 gap-4"
                >
                    <input className="border rounded-lg px-3 py-2" type="text" placeholder="ID Redenvelope" value={id_redenvelope} onChange={(e) => setIdRedenvelope(e.target.value)} />

                    <input className="border rounded-lg px-3 py-2" type="text" placeholder="Money" value={money} onChange={(e) => setMoney(e.target.value)} />


                    {/* select */}
                    <select className="border rounded-lg px-3 py-2" value={status} onChange={(e) => setStatus(e.target.value)}>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>

                    <input className="border rounded-lg px-3 py-2" type="text" placeholder="For New Users" value={for_new_users} onChange={(e) => setForNewUsers(e.target.value)} />

                    {/* date */}
                    <input className="border rounded-lg px-3 py-2" type="date" placeholder="Expire Date" value={expire_date} onChange={(e) => setExpireDate(e.target.value)} />

                    <button className="px-6 py-2 rounded-lg bg-gray-900 text-white" type="button" onClick={createGiftCode}>Submit</button>

                </form>
            </div>


                 <div className="flex gap-4 mb-4">
                    {/* Status Filter */}
                    <select
                        className="border rounded-lg px-3 py-2"
                        value={status}
                        onChange={(e) => {
                            setPage(1);
                            setStatus(e.target.value);
                        }}
                    >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                    </select>

                    {/* Used Filter */}
                    <select
                        className="border rounded-lg px-3 py-2"
                        value={used}
                        onChange={(e) => {
                            setPage(1);
                            setUsed(e.target.value);
                        }}
                    >
                        <option value="false">Unused</option>
                        <option value="true">Used</option>
                        <option value="all">All</option>
                    </select>
                </div>

            <div className="overflow-x-auto rounded-xl border bg-white">

                <table className="w-full text-sm">
                    <thead className="bg-gray-100">
                        <tr>
                            {[
                                'S.No',
                                'ID Redenvelope',
                                'Money',
                                'Used',
                                'Amount',
                                'Status',
                                'For New Users',
                                'Time',
                                'Expire Date',
                            ].map((h) => (
                                <th key={h} className="px-4 py-3 text-left">
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <UserRowSkeleton columns={8} rows={5} />
                        ) : giftCodeList.length === 0 ? (
                            <tr>
                                <td
                                    colSpan={8}
                                    className="px-4 py-6 text-center text-gray-500"
                                >
                                    No pending gift code found
                                </td>
                            </tr>
                        ) : (
                            giftCodeList.map((giftCode, i) => (
                                <tr key={giftCode.id} className="border-t">
                                    <td className="px-4 py-2">
                                        {(page - 1) * limit + i + 1}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.id_redenvelope}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.money}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode?.used ? 'Yes' : 'No'}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.amount}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.status}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode?.for_new_users ? 'Yes' : 'No'}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.time}
                                    </td>

                                    <td className="px-4 py-2">
                                        {giftCode.expire_date}
                                    </td>


                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex justify-end gap-2 mt-4">
                <button
                    disabled={page === 1}
                    onClick={() => setPage((p) => p - 1)}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                >
                    Prev
                </button>

                <span className="px-3 py-1">
                    {page} / {totalPages}
                </span>

                <button
                    disabled={page === totalPages}
                    onClick={() => setPage((p) => p + 1)}
                    className="px-3 py-1 border rounded disabled:opacity-50"
                >
                    Next
                </button>
            </div>




        </div>
    );
}
